import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITagDTO, ITagUsageDTO } from '@modeso/types__aumico-lib-companies-be';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromTagsActions from '../actions/tags.actions';
import * as fromTags from '../reducer/tags.reducer';
import { ITagsProvider } from './tags.provider.interface';

/**
 * REV-22155 — the pages' way to the tags store. Deleting via the "x" on a pill:
 * `dispatchTagUsage(id)` → page reads `getTagUsage$()` → 0 uses: `dispatchDeleteTag(id)` directly,
 * otherwise show the warning and delete only after confirmation (or `dispatchClearTagUsage()`).
 */
@Injectable({
    providedIn: 'root',
})
export class TagsProvider implements ITagsProvider {
    constructor(private store: Store<fromTags.TagsFeatureState>) {}

    dispatchTagsList(): void {
        this.store.dispatch(fromTagsActions.getTags());
    }

    dispatchCreateTag(name: string): void {
        this.store.dispatch(fromTagsActions.createTag({ name }));
    }

    dispatchTagUsage(id: string): void {
        this.store.dispatch(fromTagsActions.getTagUsage({ id }));
    }

    dispatchClearTagUsage(): void {
        this.store.dispatch(fromTagsActions.clearTagUsage());
    }

    dispatchDeleteTag(id: string): void {
        this.store.dispatch(fromTagsActions.deleteTag({ id }));
    }

    resetTagsErrors(): void {
        this.store.dispatch(fromTagsActions.resetTagsErrors());
    }

    resetTags(): void {
        this.store.dispatch(fromTagsActions.resetTags());
    }

    getTags$(): Observable<ITagDTO[]> {
        return this.store.pipe(select(fromTags.selectAllTags));
    }

    getTagNamesById$(): Observable<Record<string, string>> {
        return this.store.pipe(select(fromTags.selectTagNamesById));
    }

    getTagUsage$(): Observable<{ id: string; usage: ITagUsageDTO } | null> {
        return this.store.pipe(select(fromTags.selectTagUsage));
    }

    getTagsError$(): Observable<HttpErrorResponse | null> {
        return this.store.pipe(select(fromTags.selectTagsError));
    }
}
